import React from "react";
import styles from "./TableComponent.module.css";
const TableComponent = ({ strategies, data, ...props }) => {
  return (
    <table className={`${styles.table}`}>
      <thead>
        <tr>
          <th scope="col">Stock List</th>

          <th scope="col">Eligibility</th>
          <th scope="col">atm</th>
          <th scope="col">Selected</th>
          <th scope="col">Amount</th>
          <th scope="col">Quantity</th>
        </tr>
      </thead>
      <tbody>
        {data &&
          data.map((ele, i) => {
            return (
              <tr key={`${i}`}>
                <td className="items-center px-4 py-1">{ele.symbol}</td>
                <td className="items-center px-4 py-1"></td>
                <td className="items-center px-4 py-1"></td>
                <td className="items-center px-4 py-1"></td>
                <td className="items-center px-4 py-1"></td>
                <td className="items-center px-4 py-1">{ele.qty}</td>
              </tr>
            );
          })}
      </tbody>
    </table>
  );
};

export default TableComponent;
